import type { TrainingContact, TrainingContactPut } from '../types/trainingContacts';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useDefaultMutation } from '~/lib/react-query';
import FetchPromise from '~/agent/fetch-promise';

const TRAINING_CONTACTS_KEY = 'TRAINING_CONTACTS';

const getTrainingContacts = (courseId: string) => FetchPromise.get(`courses/${courseId}/training_contacts`);

const updateTrainingContacts = (courseId: string, trainingContacts: TrainingContactPut[]) =>
  FetchPromise.put(`courses/${courseId}/training_contacts`, { training_contacts: trainingContacts });

export const useTrainingContacts = (courseId: string, options: UseQueryOptions<TrainingContact[]> = {}) =>
  useQuery<TrainingContact[]>([TRAINING_CONTACTS_KEY, courseId], () => getTrainingContacts(courseId), options);

export const useUpdateTrainingContacts = (courseId: string) => {
  const client = useQueryClient();

  return useDefaultMutation(
    (trainingContacts: TrainingContactPut[]) => updateTrainingContacts(courseId, trainingContacts),
    {
      onSuccess: () => {
        client.invalidateQueries([TRAINING_CONTACTS_KEY, courseId]);
      },
    },
  );
};
